import { OlErrorKeys, OneLinkStatusEnum } from '../types/oneLink';
import { FilterTypesEnum } from '../types/shell';
import { DEPT_ADMIN, DISTRIBUTOR, ORG_ADMIN, SUPER_ADMIN } from './users';

import variables from '../_variables.scss';

export const UID = 'uid';
export const URL = 'url';

export const MAX_ONE_LINKS_PER_PAGE = 10;
export const MAX_RECIPIENTS_PER_PAGE = 10;
export const MIN_REDEMPTION_LIMIT = 1;
export const MAX_REDEMPTION_LIMIT = 9999999;

export const ONE_LINK_FILTERS = [
  {
    label: 'Organization',
    filterId: FilterTypesEnum.Organization,
    role: [ORG_ADMIN, DISTRIBUTOR, SUPER_ADMIN],
  },
  {
    label: 'Department',
    filterId: FilterTypesEnum.Department,
    role: [DEPT_ADMIN],
  },
  {
    label: 'Individual',
    filterId: FilterTypesEnum.Individual,
  },
];

export const ONE_LNK_TABS = [
  {
    label: 'Active',
    tabId: OneLinkStatusEnum.Active,
  },
  {
    label: 'Not active',
    tabId: OneLinkStatusEnum.NotActive,
  },
];

export const ONE_LINK_STATUS = {
  [OneLinkStatusEnum.Active]: {
    label: 'Active',
    color: variables.budgetGreen,
  },
  [OneLinkStatusEnum.NotActive]: {
    label: 'Not active',
    color: variables.errorRed,
  },
};

export const FIRST_NAME = 'first_name';
export const LAST_NAME = 'last_name';
export const EMAIL_ADDRESS = 'email';
export const PHONE_NUMBER = 'phone';

export const ERROR_EMAIL_OR_PHONE_REQUIRED = 'Email or phone is required';
export const ERROR_DUPLICATE_EMAIL = 'Duplicate email';
export const ERROR_DUPLICATE_PHONE = 'Duplicate phone';
export const ERROR_EMAIL_INVALID = 'Email is invalid';
export const ERROR_PHONE_INVALID = 'Phone is invalid';

export const ALLOWED_RECIPIENTS_TABLE_HEADERS = {
  [FIRST_NAME]: 'First name',
  [LAST_NAME]: 'Last name',
  [EMAIL_ADDRESS]: 'Email address',
  [PHONE_NUMBER]: 'Phone number',
};

export const ONE_LINK_REDEMPTION_LIMIT = 10;
export const TITLE = 'title';

export enum RowsPerPageEnum {
  Ten = 10,
  Twenty = 20,
  Fifty = 50,
}

export const DEFAULT_PAGE_NUMBER = 1;
export const DISABLED_SUBMIT_BUTTON_HINT =
  'No changes have been made to the form. Please make a change or click Cancel.';

export const ERROR_MESSAGES: Record<string, string> = {
  // frontend errors
  [OlErrorKeys.ExpirationDateOutdated]: 'Expiration date must be in the future.',
  [OlErrorKeys.SenderDeleted]: 'This sender is no longer available. Please select another.',
  [OlErrorKeys.OnHoldDateOutdated]: 'The "On Hold Until" date must be in the future.',
  [OlErrorKeys.BusinessReasonRequired]: 'Please provide a business reason.',
  [OlErrorKeys.RedemptionLimitLessThanAvailableSends]: 'Redemption limit must exceed confirmed sends.',
  [OlErrorKeys.OutOfStockItems]: 'Some items are out of stock. Please update your selection.',
  [OlErrorKeys.LessThanTwoValidCampaigns]: 'Select at least two valid campaigns.',
  [OlErrorKeys.InvalidAddresses]: 'Some addresses are invalid or inactive. Please review your list.',
  [OlErrorKeys.InvalidAddress]: 'Please check the address in your send.',
  // backend errors
  [OlErrorKeys.SomeItemsInvalid]: 'One or more items are invalid. Please review your selection.',
  [OlErrorKeys.SomeCampaignsNotFound]: 'Some campaigns couldn’t be found. Please verify your list.',
  [OlErrorKeys.SomeCampaignsNotActive]: 'Some campaigns are inactive. Please choose active ones.',
  [OlErrorKeys.PickYourGiftNeedsTwoOrMoreCampaigns]: 'Pick Your Gift requires at least two campaigns.',
  [OlErrorKeys.EngagementHasBothItemsAndPickYourGiftCampaigns]: 'You can’t combine items and Pick Your Gift campaigns.',
  [OlErrorKeys.CampaignNotFound]: 'Campaign not found. Please check the campaign name or ID.',
  [OlErrorKeys.CampaignNotActive]: 'The selected campaign is inactive.',
  [OlErrorKeys.BusinessReasonInvalid]: 'Invalid business reason. Please enter a valid one.',
  [OlErrorKeys.MaxSubmitCountInvalidValue]: 'Invalid maximum submit count: %v.',
  [OlErrorKeys.MaxSubmitCountLessThanOneLinkUsed]: 'Submit count must be at least %v (current OneLink uses).',
  [OlErrorKeys.SenderNotFound]: 'Sender not found. Please select a valid sender.',
  [OlErrorKeys.SenderNotFromSameOrganization]: 'Sender must belong to your organization.',
  [OlErrorKeys.ExpirationDateShouldBeInFuture]: 'Expiration date must be in the future.',
  [OlErrorKeys.ReceiverAddressDuplicated]: 'Duplicate receiver address found. Please remove duplicates.',
  [OlErrorKeys.ReceiverAddressMissing]: 'Receiver address is required.',
  [OlErrorKeys.ErrorHappenedWhileFindingAddresses]: 'Error finding addresses. Please try again.',
  [OlErrorKeys.SomeAddressesDontBelongToCurrentOrganization]: 'Some addresses don’t belong to your organization.',
  [OlErrorKeys.OnlyActiveAddressesCanBeAddedToAddressBook]: 'Only active addresses can be added to the address book.',
};

export const EXPIRATION_DATE_ERROR_TOOLTIP_TEXT = 'Expiration date cannot be in the past. Choose a valid date.';
export const ON_HOLD_ERROR_TOOLTIP_TEXT =
  'The On Hold Date has already passed. Set a new date in the present or future.';
export const SHIPPING_ERROR_TOOLTIP_TEXT =
  'Some of the selected addresses are no longer valid. To activate the One Link, please update your selection by choosing a new address or removing the invalid one.';
export const SENDER_ERROR_TOOLTIP_TEXT = 'The selected sender is inactive. Select a different sender to proceed.';
export const REDEMPTION_LIMIT_ERROR_TOOLTIP_TEXT =
  'The redemption limit must be greater than or equal to the number of available sends.';
export const INVENTORY_ERROR_TOOLTIP_TEXT =
  'Some of the sent items are out of stock. To activate the One Link, please update your selection by choosing available items or removing the unavailable ones.';
